import type { AuiRendererProps } from '../registry';

export function AuiFallback({ node, children }: AuiRendererProps) {
  return (
    <div
      className="rounded-md border border-dashed border-muted-foreground/30 bg-muted/50 p-3"
      data-testid="aui-fallback"
    >
      <p className="text-xs text-muted-foreground">
        Unknown component: <code>{node.component.type}</code>
      </p>
      {children && <div className="flex flex-col gap-4">{children}</div>}
    </div>
  );
}
